<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="h-auto overflow-auto flex flex-col import_contact">
      <woot-modal-header :header-title="$t('IMPORT_CONTACTS.TITLE')" />
      <div class="flex flex-col px-8 pb-8 pt-2">
        <p>
          {{ $t('IMPORT_CONTACTS.DESC') }}
          <a :href="csvUrl" download="import-contacts-sample">{{ $t('IMPORT_CONTACTS.DOWNLOAD_LABEL') }}</a>
        </p>

        <div class="w-full mt-4">
          <label>
            <span>
              {{ $t('IMPORT_CONTACTS.FORM.LABEL') }} <span class="text-red-500"> *</span>
            </span>
            <input id="file" ref="file" type="file" accept="text/csv" @change="handleFileUpload" />
          </label>
          <div v-if="file" class="mt-2 text-sm text-gray-600">
            Selected: {{ file.name }}
        </div>
        </div>

        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <div class="w-full">
            <woot-button :disabled="!file" @click="submit" class="data-change">
              {{ $t('IMPORT_CONTACTS.FORM.SUBMIT') }}
            </woot-button>
        
            <button v-if="!file" class="button clear" @click.prevent="onClose">
              {{ $t('IMPORT_CONTACTS.FORM.CANCEL') }}
            </button>

            <button v-if="file" class="button clear" @click.prevent="clearFile">
                Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../components/Modal';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: { Modal },
  mixins: [alertMixin],
  props: { 
    onClose: { type: Function, default: () => {} } ,
    importSelection: { type: File, default: () => {} }
},
  data() {
    return { show: true, file: '' };
  },
  computed: {
    csvUrl() {
      return '/downloads/import-contacts-sample.csv';
    },
  },
  mounted() {
    console.log("importSelection mounted - - -- - - - - - -= == =  =||||| ", this.importSelection);
    this.file = this.importSelection;
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submit() {
      if (!this.file) return;
      this.$emit('selected-import', { file: this.file });
      this.onClose();
    },
    clearFile() {
      this.file = null;
      this.$refs.file.value = '';
      this.$emit('selected-import', { file: null });
    },
  },
};
</script>

<style scoped>
.data-change { background-color: #40518a !important; }
</style>
